import { CardCorners, ContinueWatchCard } from '@setplex/arcana'
import { useUnit } from 'effector-react'
import { useCallback, type MouseEvent } from 'react'
import type { IContinueWatchingCardFormat } from '~/entities/continue-watching'
import * as pinLockFeature from '~/features/pin-lock'
import {
  VodCardHorizontalCoversMap,
  VodCardVerticalCoversMap,
} from '~/shared/ui/components/cardCovers'
import type { ViewRow } from '~/widgets/DynamicModule'
import { getCWCardPadding, getCardFonts } from '../lib'

export const CWCard = ({
  row,
  item,
}: {
  row: ViewRow
  item: IContinueWatchingCardFormat
}) => {
  const {
    progress,
    contentName,
    landscapeImageUrl,
    portraitImageUrl,
    description,
    viewedTime,
    contentId,
  } = item

  const {
    appearance: {
      style: { posterSize, posterOrientation },
    },
  } = row

  const { isLocked, intercept } = useUnit({
    isLocked: pinLockFeature.$isLockedFn,
    intercept: pinLockFeature.intercept,
  })

  const id = item.contentType === 'EPISODE' ? item.tvShowId : item.contentId

  const locked = isLocked({
    id,
    locked: item.locked,
  })

  const handleSelectContinueWatching = useCallback(
    (event: MouseEvent<Element>) => {
      intercept({
        id,
        locked,
        name: contentName,
        '<event>': event,
      })
    },
    [id, intercept, contentName, locked]
  )

  const posterUrl =
    posterOrientation === 'HORIZONTAL' ? landscapeImageUrl : portraitImageUrl

  const { titleFont, labelFont } = getCardFonts(posterSize)
  const padding = getCWCardPadding(posterSize)
  const covers =
    posterOrientation === 'HORIZONTAL'
      ? VodCardHorizontalCoversMap
      : VodCardVerticalCoversMap

  const href =
    item.contentType === 'VOD'
      ? `/player/movie?vodId=${item.contentId}&categoryId=0`
      : `/player/series?${item.tvShowId ? `tvshowId=${item.tvShowId}&` : ''}${item.withSeason && item.seasonId ? `seasonId=${item.seasonId}&` : ''}episodeId=${contentId}&categoryId=0`

  return (
    <a href={href}>
      <ContinueWatchCard
        onClick={handleSelectContinueWatching}
        corners={CardCorners.CORNERS_25}
        titleFont={titleFont}
        progress={progress}
        posterUrl={posterUrl}
        title={contentName ?? ''}
        description={description}
        durationTitle={viewedTime}
        locked={Boolean(locked)}
        lockedTitle={contentName}
        padding={padding}
        labelFont={labelFont}
        covers={covers}
        ageRatingLabel=''
      />
    </a>
  )
}
